/**
 * Provides the Heap script to inject.
 */
const getHeapScript = (id: string | number) => `
  (window.heap = window.heap || []),
  (heap.load = function (e, t) {
    (window.heap.appid = e), (window.heap.config = t = t || {});
    var r = document.createElement("script");
    (r.type = "text/javascript"),
      (r.async = !0),
      (r.src = "https://cdn.heapanalytics.com/js/heap-" + e + ".js");
    var a = document.getElementsByTagName("script")[0];
    a.parentNode.insertBefore(r, a);
    for (
      var n = function (e) {
          return function () {
            heap.push(
              [e].concat(Array.prototype.slice.call(arguments, 0)),
            );
          };
        },
        p = [
          "addEventProperties",
          "addUserProperties",
          "clearEventProperties",
          "identify",
          "resetIdentity",
          "removeEventProperty",
          "setEventProperties",
          "track",
          "unsetEventProperty",
        ],
        o = 0;
      o < p.length;
      o++
    )
      heap[p[o]] = n(p[o]);
  });

heap.load("${id}", {
  rewrite: function (props) {
    return Object.assign(props, {
      pageview_properties: Object.assign(props.pageview_properties, {
        domain: "canopy",
      }),
    });
  },
});
`;

const scriptId = "jsq-heap-script";
const productionId = "2727357492";
const stagingId = "2234022012";

function getHeapId() {
  const { hostname } = window.location;
  const hostnameParts = hostname.split(".");
  if (hostname === "admin.junipersquare.com") {
    return productionId;
  }
  if (hostnameParts.length === 4 && hostnameParts[0] === "admin") {
    if (["prodops", "cit", "demo"].includes(hostnameParts[1])) {
      return productionId;
    }
    if (hostnameParts[1] === "staging") {
      return stagingId;
    }
  }
  return undefined;
}

/**
 * Initializes Heap tracking.
 */
export function initializeHeap() {
  const id = getHeapId();
  if (!id) {
    return;
  }

  const hasScript = document.getElementById(scriptId);
  if (hasScript !== null) {
    return;
  }

  const script = document.createElement("script");
  script.innerHTML = getHeapScript(id);
  script.id = scriptId;
  script.async = true;
  script.defer = true;
  document.body.appendChild(script);
}
